import "babel-polyfill";
import Vue from "vue";
import VueGtag from 'vue-gtag';
import VueHead from 'vue-head';
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createProvider } from "./vue-apollo";
import VueScrollReveal from "vue-scroll-reveal";
import "animate.css";
import store from "./store";

Vue.config.productionTip = false;
Vue.use(VueScrollReveal);
Vue.use(VueGtag, {
  config: {
    id: 'UA-170207508-1'
  },
}, router);
Vue.use(VueHead);

new Vue({
  router,
  vuetify,
  apolloProvider: createProvider(),
  store,
  render: (h) => h(App),
}).$mount("#app");
